<template>
  <div id="main-content" class="edit-class">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <form>
        <el-row class="mt-3">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('grade.name') }}</span>
            </el-col>
            <el-col :span="16">
              <div class="text-left font-weight-bold mt-1">{{grade.name}}</div>
            </el-col>
            <el-col v-if="errName" :offset="8" :span="16">
              <span class="form-error"> {{ errName }}</span>
            </el-col>
          </el-col>

        </el-row>


        <el-row style="padding-top: 50px">
          <el-button style="font-size: 20px; width: 30%" type="success" @click="onShowEdit">{{ $t('common.edit') }}</el-button>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
import PageTitle from '../../components/PageTitle.vue'

export default {
  name: "EditClass",
  components: {
    PageTitle
  },
  data: function () {
    return {
      title:'grade.titleDetail',
      backLink:'/grade-management',
      grade:{
        id:null,
        name:null
      },
      errName:null
    }
  },
  created(){

  },
  mounted() {
    this.onGetGradeById(this.$route.params.id)
  },
  methods:{
    onShowEdit(){
      this.$router.push({name: `grade-management-edit`, query:{id:this.grade.id}});
    },
    onGetGradeById(id){
      let payload ={
        successCallback: (response) =>{
          if(response.status === 200){
            this.grade= response.data.data.grade
          }
        },
        errorCallback: () => {},
        grade_id:id
      }
      this.$store.dispatch('classroom/getGradeById', payload)
    }
  }
}
</script>

<style lang="scss">
</style>
